import { baseSetting } from "../setting";
import Vue from 'vue'; // @ts-ignore

import shareComponent from '@tencent/vft-vue-plugins/src/dialog/shareComponent.vue';
export function setup() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$use = _ref.use,
      use = _ref$use === void 0 ? true : _ref$use;

  if (use) {
    if (!Vue.prototype.share) {
      shareComponent.install(Vue);
    }

    setDefaultShare();
  }
}
export function setDefaultShare() {
  var setShare = Vue.prototype.share.setShare;
  var 默认分享 = baseSetting.默认分享;
  setShare(Object.assign({
    imgUrl: 默认分享.分享图,
    title: 默认分享.分享标题,
    desc: 默认分享.分享描述,
    timeLineTitle: 默认分享.分享朋友圈标题,
    link: 默认分享.分享链接
  }));
}